import * as React from "react"
const CrossMark = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      fill="#2E2E2E"
      stroke="#2E2E2E"
      strokeWidth={0.3}
      d="m8.8 8.5 4.742-4.743a.552.552 0 0 0 0-.8.552.552 0 0 0-.8 0L8 7.699 3.257 2.957a.552.552 0 0 0-.8 0 .552.552 0 0 0 0 .8l4.742 4.742-4.742 4.743a.552.552 0 0 0 0 .8.552.552 0 0 0 .8 0L7.999 9.3l4.743 4.743a.552.552 0 0 0 .8 0 .552.552 0 0 0 0-.8L8.8 8.5Z"
    />
  </svg>
)
export default CrossMark
